export default __webpack_public_path__ + "static/step-3-88a7d3cfa2fc1dab4de3f8f1cefbcf95.webp";